<template>
  <div class="carousel-wrapper">
    <swiper :ref="reference" :options="options">
      <swiper-slide v-for="slide in slides" :key="slide.id">
        <div class="block">
          <p class="name" v-html="slide.name"></p>
          <p class="country">{{slide.country}}</p>
          <p class="percent">{{slide.percent}}</p>
        </div>

        <div v-if="slide.child" class="block block-child">
          <p class="name" v-html="slide.child.name"></p>
          <p class="country">{{slide.child.country}}</p>
          <p class="percent">{{slide.child.percent}}</p>
        </div>
      </swiper-slide>
    </swiper>

    <!-- <div class="navigation">
      <button type="button" class="button-prev" @click="prevSlide">
        <i class="icon-arrow-left"></i>
      </button>
      <button type="button" class="button-next" @click="nextSlide">
        <i class="icon-arrow-right"></i>
      </button>
    </div> -->
  </div>
</template>

<script>
  import {
    Swiper,
    SwiperSlide
  } from 'vue-awesome-swiper'

  export default {
    components: {
      Swiper,
      SwiperSlide
    },
    props: {
      reference: {
        type: String,
        required: false,
        default: null
      },
      slides: {
        type: Array,
        required: true,
        default: []
      }
    },
    data() {
      return {
        options: {
          slidesPerView: 1.7,
          spaceBetween: 10,
          autoplay: {
            disableOnInteraction: false
          },
          speed: 2000,
          breakpoints: {
            1200: {
              slidesPerView: 6,
            },
            992: {
              slidesPerView: 5.5,
            },
            768: {
              slidesPerView: 4.5,
            },
            576: {
              slidesPerView: 2.5,
            },
          }
        }
      }
    },
    methods: {
      nextSlide() {
        this.$refs[this.reference].$swiper.slideNext()
      },
      prevSlide() {
        this.$refs[this.reference].$swiper.slidePrev()
      },
    },
  }
</script>

<style scoped lang="scss"></style>